import zhCN from './json/questionnaire.zh_CN.json';
import zhTW from './json/questionnaire.zh_TW.json';
import en from './json/questionnaire.en.json';
import ja from './json/questionnaire.ja.json';
import ko from './json/questionnaire.ko.json';
import ru from './json/questionnaire.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
